import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { getPropByName } from '../../../utils/props';
import { UserAddresses } from './UserAddresses';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class UserAddressesCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    const user = this.props.user;
    return (
      <Card className="user-info-card info-card data">
        <Container>
          <h2>{this.lbl('user.info.addresses.title')}</h2>
          {/* <List>{user.addresses?.map(this.renderAddress.bind(this))}</List> */}
          <UserAddresses user={user} />
        </Container>
      </Card>
    );
  }

  renderAddress(address, index) {
    return (
      <Row clickable key={address.id} onClick={this.tofn(`/addresses/${address.id}`)}>
        <Cell>{getPropByName(address, 'name', '')}</Cell>
      </Row>
    );
  }
}

UserAddressesCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const UserAddressesCard = compose(
  withConnect,
  withRouter,
)(UserAddressesCardComp);
